import React from "react"
import ReactDOM from "react-dom"
import "./Modal.scss"

const Modal = ({
    show,
    onHide,
    children,
    className,
    styles = {},
  }: {
    show: boolean
    onHide: () => void
    children: React.ReactNode,
    className: string,
    styles?: React.CSSProperties
  }) => {
  
    const handleOverlayClick = (e: React.MouseEvent) => {
      if (e.target === e.currentTarget) {
        onHide()
      }
    }

    return ReactDOM.createPortal(
      <div className={`overlay ${show ? 'show' : ''}`} onClick={handleOverlayClick}>
        <div className={`modal ${show ? 'pop' : ''} ${className || ""}`} style={styles}>
          <button onClick={onHide} className="close-button">
            &times;
          </button>
          {children}
        </div>
      </div>,
      document.getElementById('modal-root')!
    )
  }
  
  export default React.memo(Modal)